import React from 'react'
import styled from 'styled-components'

export const Header = () => {
	return(
		<StyledHeader>
			<h1>Free Email Signature Generator</h1>
			<p> Generate a custom HTML email signature in seconds for free</p>
		</StyledHeader>
	)
}

const StyledHeader = styled.div`
	margin-bottom: 2rem;
	text-align: center;
	font-size: 14px;
	h1 {
		font-family: 'Montserrat', sans-serif;
		color: #311b92;
		font-size: 2.625rem;
		font-weight: 700;
		margin: 1rem 0 0;
	}
	p {
		font-family: 'Montserrat', sans-serif;
		font-size: 20px;
		font-weight: 100;
	}

`
